import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled, { css } from 'styled-components';
import { getPropsBlocker, makePropList } from '../../utils';
import { sizeAttributes } from '../../system/attributes';
var propertyList = makePropList(['gutterSpacing', 'gutterSpacingVertical', 'gutterSpacingHorizontal']);
export var setHorizontalMargin = function setHorizontalMargin(value, spacing) {
  var marginValue = spacing(value);
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        margin-right: calc(", " * 0.5);\n        margin-left: calc(", " * 0.5);\n    "])), marginValue, marginValue);
};
export var setVerticalMargin = function setVerticalMargin(value, spacing) {
  var marginValue = spacing(value);
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        margin-top: calc(", " * 0.5);\n        margin-bottom: calc(", " * 0.5);\n    "])), marginValue, marginValue);
};

var gridRootStyle = function gridRootStyle(_ref) {
  var gutterSpacing = _ref.gutterSpacing,
      gutterSpacingVertical = _ref.gutterSpacingVertical,
      gutterSpacingHorizontal = _ref.gutterSpacingHorizontal,
      _ref$theme = _ref.theme,
      Grid = _ref$theme.componentOverrides.Grid,
      spacing = _ref$theme.spacing;
  var result = Grid.Root.base;
  var gutterSpacingX = gutterSpacingHorizontal || gutterSpacing;
  var gutterSpacingY = gutterSpacingVertical || gutterSpacing;

  if (gutterSpacingX && gutterSpacingX > 0) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n        "])), result, setHorizontalMargin(-gutterSpacingX, spacing));
  }

  if (gutterSpacingY && gutterSpacingY > 0) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n        "])), result, setVerticalMargin(-gutterSpacingY, spacing));
  }

  return result;
};

export var GridRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n    ", "\n    ", "\n"])), gridRootStyle, sizeAttributes);